/* eslint-disable no-shadow */
const state = {
	recentlyViewedProductIds: [],
	recentlyViewedProducts: [],
	step: false
}

const getters = {
	getRecentViewedProducts: state => state.recentlyViewedProductIds,
	getRecentViewedProductsData: state => state.recentlyViewedProducts
}

const mutations = {
	setRecentProductsMutation: (state, payload) => {
		// state.recentlyViewedProductIds = [];
		if (state.recentlyViewedProductIds.length <= 10) {
			const product = state.recentlyViewedProductIds
				.filter(recentlyViewedProductIds => recentlyViewedProductIds === payload)
			if (product.length === 0) {
				state.recentlyViewedProductIds.push(payload)
			} else {
				const index = state.recentlyViewedProductIds.findIndex(
					cartProducts => cartProducts === payload
				)
				state.recentlyViewedProductIds.splice(index, 1)
				state.recentlyViewedProductIds.push(payload)
			}
		} else {
			const product = state.recentlyViewedProductIds
				.filter(recentlyViewedProductIds => recentlyViewedProductIds === payload)
			if (product.length === 0) {
				state.recentlyViewedProductIds.splice(0, 1)
				state.recentlyViewedProductIds.push(payload)
				state.recentlyViewedProductIds.push(payload)
			} else {
				const index = state.recentlyViewedProductIds.findIndex(
					cartProducts => cartProducts === payload
				)
				state.recentlyViewedProductIds.splice(index, 1)
				state.recentlyViewedProductIds.push(payload)
			}
		}
	},
	clearRecentProductsMutation: (state) => {
		state.recentlyViewedProductIds = []
		state.recentlyViewedProducts = []
	},
	setRecentProductsDataMutation: (state, payload) => {
		state.recentlyViewedProducts = payload
	}
}

const actions = {
	setRecentProductsData: ({
		commit
	}, payload) => {
		commit('setRecentProductsMutation', payload)
	},
	setRecentSelectedProductsData: ({
		commit
	}, payload) => {
		commit('setRecentProductsDataMutation', payload)
	},
	clearRecentProductsData: ({
		commit
	}) => {
		commit('clearRecentProductsMutation')
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
}
